(function () {
    "user strict";

    angular
        .module("UndergroundWebApp")
        .factory("deviceEventService", deviceEventService);

    deviceEventService.$inject = ["$q", "$http", "qPool"];

    function deviceEventService($q, $http, qPool) {
        var service = {
            getDeviceEvents,
        };

        function getDeviceEvents(deviceExternalId, fromDate, toDate, maxHits, eventTypes) {
            let deferred = qPool.defer("express");

            if (!deferred.hasCompleted() && deferred.isFirst) {
                $http
                    .get(`api/device/device-events`, {
                        params: { deviceExternalId, fromDate, toDate, maxHits, eventTypes },
                    })
                    .then(
                        function (result) {
                            deferred.resolve(result.data);
                        },
                        function () {
                            deferred.reject();
                        }
                    );
            }

            return deferred.promise;
        }

        return service;
    }
})();
